import { ThankYou } from "./components/thankYou";
import { Home } from "./components/Home";
import { Error } from "./components/Error";
import { Construction } from "./components/Construction";

const AppRoutes = [
  {
    index: true,
    element: <Home />,
  },
  {
    path: "/thankYou",
    element: <ThankYou />,
  },
  {
    path: "/Error",
    element: <Error />,
  },
  {
    path: "/Construction",
    element: <Construction />,
  },
];

export default AppRoutes;
